import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Content from '../Content';
import metaOverrideSet from '../MetaOverrideSet';

const styles = () => ({
  root: {},
});

const AccountOpeningAgreementTemplate = ({
  className,
  classes,
  resource,
}) => {
  const { loadPageContentLink } = usePageContentContext();

  async function handleNext() {
    const [nextStep] = await resource.submit();
    loadPageContentLink(nextStep.relationship(fr.relationships.CIPWizard.name).link('related'));
  }

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
      onNext={handleNext}
      LayoutProps={{
        ErrorListProps: {
          scrollIntoView: true,
        },
      }}
    />
  );
};

AccountOpeningAgreementTemplate.defaultProps = {
  className: '',
};

AccountOpeningAgreementTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(AccountOpeningAgreementTemplate);
